import Icon from '../components/Icon.vue'

Icon.register({
  magnet: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M164.1 148.1h-152.1c-6.6 0-12-5.4-12-12v-80c0-19.9 16.1-36 36-36h104c19.9 0 36 16.1 36 36v80c0 0 0 0.1 0 0.1 0 6.6-5.3 11.9-11.9 11.9h0zM512 136.1c0 6.6-5.3 11.9-11.9 11.9 0 0-0.1 0-0.1 0h-152c-6.6 0-12-5.4-12-12v-80c0-19.9 16.1-36 36-36h104c19.9 0 36 16.1 36 36v80.1zM348 180.1h151.8 0c6.6 0 12 5.4 12 12 0 0 0 0.1 0 0.1-0.2 20.2-0.6 40.4 0 53.2 0 150.7-134.4 246.7-255 246.7s-256.8-96-256.8-246.6c0.6-13 0.1-31.9 0-53.3v-0.1c0-6.6 5.4-12 12-12v0h151.9c6.6 0 12 5.4 12 12v52c0 127.9 160 128.1 160 0v-52c0-6.6 5.4-12 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/magnet.js
// module id = 1539
// module chunks = 0